import { Share2, Link as LinkIcon, Twitter, Facebook } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { toast } from '@/hooks/use-toast';

export function NewsShare({ title }: { title: string }) {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  const enc = encodeURIComponent;
  const links = {
    twitter: `https://twitter.com/intent/tweet?url=${enc(url)}&text=${enc(title)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(url)}`,
    whatsapp: `https://wa.me/?text=${enc(`${title} ${url}`)}`,
    telegram: `https://t.me/share/url?url=${enc(url)}&text=${enc(title)}`,
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(url); toast({ title: 'Link copied' }); }
    catch { toast({ title: 'Could not copy', variant: 'destructive' }); }
  };
  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch { /* cancelled */ }
    } else copyLink();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="gap-1.5">
          <Share2 className="h-4 w-4" />
          <span className="hidden sm:inline">Share</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={copyLink}><LinkIcon className="h-4 w-4 mr-2" /> Copy link</DropdownMenuItem>
        <DropdownMenuItem onClick={nativeShare}><Share2 className="h-4 w-4 mr-2" /> Share…</DropdownMenuItem>
        <DropdownMenuItem asChild><a href={links.twitter} target="_blank" rel="noopener noreferrer"><Twitter className="h-4 w-4 mr-2" /> X / Twitter</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a href={links.facebook} target="_blank" rel="noopener noreferrer"><Facebook className="h-4 w-4 mr-2" /> Facebook</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a href={links.whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp</a></DropdownMenuItem>
        <DropdownMenuItem asChild><a href={links.telegram} target="_blank" rel="noopener noreferrer">Telegram</a></DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
